import { ApiModel, ApiModelOptions } from "../../../ApiModel";
import { PrincipalModel } from "../../../models";

export default function apiPrincipalModel(
  opts: ApiModelOptions<PrincipalModel>,
) {
  const model = ApiModel<PrincipalModel>("principal", {
    usePlacement: true,
    ...opts,
  });

  const uploadPictureBlob = async (principalId: string, blob: Blob) => {
    return await model.placementsApiClient.uploadRequest(
      "images",
      blob,
      {
        principal_id: principalId,
        image_type: "principal",
        filename: "principal-avatar.png",
      },
      () => null,
    );
  };

  return { ...model, uploadPictureBlob };
}
